import React from 'react'
import PropTypes from 'prop-types'
import {Fade} from "reactstrap";


const sizeToFontAwesomeSize = {
    xs: 'fa-xs',
    sm: 'fa-sm',
    md: '',
    lg: 'fa-lg',
    xl: 'fa-2x',
}

/**
 * Loading icon.
 **/
export class Spinner extends React.Component {
  static propTypes = {
    center: PropTypes.bool,
    timeout: PropTypes.number.isRequired,
    size: PropTypes.oneOf(['xl', 'lg', 'md', 'sm', 'xs']),
    message: PropTypes.string
  }

  static defaultProps = {
    timeout: 1000,
    size: 'lg'
  }

  render() {
    // console.warn("TODO - remove className 'in' for compatibility chrome dome stylepack");
    // TODO - Standardize loaders. Some are H4's some are using this. Let's move to this. H4 isn't the right element for this.
    const {center, timeout, size, message, ...props} = this.props;
    const Container = (center) ? CenterContent : 'span';
    return (<Container {...props}>
      <Fade
        in={true}
        timeout={timeout}
        className="in"
        >
          <div className="d-flex flex-row align-items-center">
            <i className={`d-flex align-items-center fas fa-spinner fa-spin ${sizeToFontAwesomeSize[size] || sizeToFontAwesomeSize.lg}`} style={{ textDecoration: "none" }}></i> 
            {!!message ? <div className="control-spacer-left font-weight-bold">{message}</div> : null}
          </div>
      </Fade>
    </Container>)
  }
}




export const CenterContent = ({ children, style, className }) => <div style={{
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}}>
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      ...style
    }}
    className={className}
  >{
    children
  }</div>
</div>
